import Vue from 'vue'
import Router from 'vue-router'
import store from '../store';
import CallParkingWallboard from "../components/callParkingWallboard/CallParkingWallboard.vue";
import Login from "../components/login/Login.vue";

Vue.use(Router)

let router = new Router({
    // mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: CallParkingWallboard,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                requiresAuth: false
            }
        }
    ]
});

router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth) && !store.getters['isLoading']) {
        if (store.getters['isLoggedIn']) {
            next();
            return;
        }
        next('/login');
    } else if (to.name === 'login' && store.getters['isLoggedIn']) {
        next('/');
    } else {
        next();
    }
});

export default router;